import flatpickr from 'flatpickr';
import language from 'flatpickr/dist/l10n/it';

flatpickr.localize(language.it);
global.flatpickr = function () {
  console.log('Component flatpickr', !!document.querySelectorAll('.flatpickr').length);
  global.flatpickr = flatpickr;
  flatpickr(...arguments);
};
